module["exports"] = [
  "ul.",
  "al."
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/pl/address/street_prefix.js
// module id = 1447
// module chunks = 0